import { IShipperRateUpdatesAllowed, IStatusTimezoneScheme } from 'types/graphqlTypes'
import * as yup from 'yup'

export const ShipperEdiUpdateSettingsSchema = yup.object({
  statusTimezoneScheme: yup
    .mixed<IStatusTimezoneScheme>()
    .oneOf([...Object.values(IStatusTimezoneScheme)])
    .nullable(),
  sendsAppointmentMessagesOnlyWhenConfirmed: yup.boolean().nullable(),
  sendsAppointmentTimesOnShipmentCreation: yup.boolean().nullable(),
  shipperRateUpdatesAllowed: yup
    .mixed<IShipperRateUpdatesAllowed>()
    .oneOf([...Object.values(IShipperRateUpdatesAllowed)])
    .nullable(),
})

export type TShipperEdiUpdateSettingsSchema = yup.InferType<typeof ShipperEdiUpdateSettingsSchema>
